module.exports = __webpack_public_path__ + "img/logo_1.b4c1ccaf.png";